import { Link } from "react-router-dom";
import { brandNamesJson, domainsJson } from "./constants";

export const getLogoWithDomain = (domain) => {
  return `/${Object.keys(domainsJson).find((key) => key === domain)}.png`;
};

export const getDomainName = (domain, currentDomain) => {
  if (currentDomain) {
    return brandNamesJson[domain];
  } else {
    const otherDomains = Object.keys(brandNamesJson).filter((key) => key !== domain);
    return otherDomains.map((key) => brandNamesJson[key]);
  }
};

export const OtherLogos = ({ mainDomain }) => {
  const otherDomains = Object.keys(domainsJson).filter((key) => key !== mainDomain);

  return (
    <>
      {otherDomains.map((domain) => (
        <Link to={`${domainsJson[domain]}`} key={domain}>
          <img
            key={domain}
            src={getLogoWithDomain(domain)}
            alt={`${domain} logo`}
            style={{
              width: "80px",
            }}
          />
        </Link>
      ))}
    </>
  );
};

export const extractDateFromDescription = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  const dateLine = text.split("\n").find((line) => line.trim().startsWith("Date:"));
  if (!dateLine) return "";

  return dateLine.replace("Date:", "").trim();
};
